// Survive Chrome / Google Translate page-translate.
//
// Translate rewrites text nodes (wraps them in <font> and relocates them). Vue's
// virtual-DOM patch then calls removeChild / insertBefore on a node whose parent
// changed underneath it, which throws an uncaught DOMException and white-screens
// the whole app ("Failed to execute 'removeChild'…" / "…'insertBefore'…").
//
// We can't mark every data surface (v-no-translate is whack-a-mole and teleported
// overlays escape it), so this is the global safety net: make both ops tolerant of
// exactly the parent-mismatch case Translate creates — the only case where the
// native call would throw — so legitimate code is unaffected.
//
// Installed once, before createApp(), so it is in place before any translation can
// start. Idempotent via a marker on the shared prototype (survives HMR re-import).

const GUARD_KEY = '__wpTranslateCrashGuard';

export function installTranslateCrashGuard() {
  if (typeof Node !== 'function' || !Node.prototype) return;
  if (Node.prototype[GUARD_KEY]) return;
  Node.prototype[GUARD_KEY] = true;

  const realRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild(child) {
    if (child && child.parentNode !== this) {
      if (import.meta.env.DEV) {
        console.warn('[translate-guard] removeChild: child is not a child of this node', child, this);
      }
      return child;
    }
    return realRemoveChild.call(this, child);
  };

  const realInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (import.meta.env.DEV) {
        console.warn('[translate-guard] insertBefore: reference node is not a child of this node', referenceNode, this);
      }
      return newNode;
    }
    return realInsertBefore.call(this, newNode, referenceNode);
  };
}
